var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { fieldset, input, inputWrapper, label, labelSingle, innerWrapper, innerWrapperChecked, labelWidth, } from '../styles/legacy';
import { fieldset as fieldsetCitron, input as inputCitron, inputWrapper as inputWrapperCitron, label as labelCitron, labelSingle as labelSingleCitron, innerWrapper as innerWrapperCitron, innerWrapperChecked as innerWrapperCheckedCitron, styledInput as styledInputCitron, styledInputChecked, styledInputCheckedDisabled, styledInputDisabled, } from '../styles/citron';
import { Icon } from '@citrus/icon';
import { getStyleNames } from '@citrus/runtime';
/*
<FieldSet>
  <Label>
    <InputWrapper />
    <TextWrapper />
  </Label>
</FieldSet>
*/
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { citrusStyled } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
export var FieldSet = citrusStyled.div('fieldset', { legacy: fieldset, citrus2022: fieldsetCitron });
export var InputWrapper = citrusStyled.div('inputWrapper', {
    legacy: inputWrapper,
    citrus2022: inputWrapperCitron,
});
var XLabel = citrusStyled.label('label', { legacy: label, citrus2022: labelCitron });
var XLabelSingle = citrusStyled.label('labelSingle', { legacy: labelSingle, citrus2022: labelSingleCitron });
export var InnerWrapper = citrusStyled.div('innerWrapper', {
    legacy: innerWrapper,
    citrus2022: innerWrapperCitron,
});
export var InnerWrapperChecked = citrusStyled.div('innerWrapperChecked', {
    legacy: innerWrapperChecked,
    citrus2022: innerWrapperCheckedCitron,
});
export var TextWrapper = citrusStyled.div('N/A', null);
export var Checkbox = citrusStyled.input('input', { legacy: input, citrus2022: inputCitron });
export var StyledInput = citrusStyled.div('input', { legacy: null, citrus2022: styledInputCitron });
export var LabelSingleWrapper = citrusStyled.div('labelSingleWrapper', null);
export var Label = React.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, columns = _a.columns, className = _a.className, ariaLabelledBy = _a.ariaLabelledBy;
    var emotionObj = (_b = {},
        _b[emotionCss(labelWidth(columns))] = isNotNullOrEmpty(columns),
        _b);
    var classes = cx(emotionObj, className || '');
    var labelledBy = __assign({}, (ariaLabelledBy && { 'aria-labelledby': ariaLabelledBy }));
    return (React.createElement(XLabel, __assign({ styleNames: columns && ["col".concat(columns)] }, labelledBy, { className: classes, ref: ref }), children));
});
export var LabelSingle = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className;
    return (React.createElement(XLabelSingle, { className: className, ref: ref }, children));
});
export var CitronInput = function (_a) {
    var _b;
    var _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.selected, selected = _d === void 0 ? false : _d, _e = _a.visible, visible = _e === void 0 ? false : _e, onClick = _a.onClick;
    if (!visible)
        return null;
    var emotionObj = (_b = {},
        _b[emotionCss(styledInputDisabled)] = !selected && disabled,
        _b[emotionCss(styledInputCheckedDisabled)] = selected && disabled,
        _b[emotionCss(styledInputChecked)] = selected,
        _b);
    var classes = cx(emotionObj);
    var styleNames = {
        styledInputDisabled: emotionObj[emotionCss(styledInputDisabled)],
        styledInputCheckedDisabled: emotionObj[emotionCss(styledInputCheckedDisabled)],
        styledInputChecked: emotionObj[emotionCss(styledInputChecked)],
    };
    return (React.createElement(StyledInput, { className: classes, styleNames: getStyleNames(styleNames), onClick: onClick },
        React.createElement(Icon, { bold: true, "data-style": "checkmark", name: "checkmark", size: "xsmall" })));
};
export var Styled = {
    CitronInput: CitronInput,
    Checkbox: Checkbox,
    FieldSet: FieldSet,
    InputWrapper: InputWrapper,
    Label: Label,
    TextWrapper: TextWrapper,
    InnerWrapper: InnerWrapper,
    InnerWrapperChecked: InnerWrapperChecked,
};
